import { createReducer, combineReducers } from "redux-starter-kit";

const initialState = {
  loading: true,
  error: null,
  statusFilterOptions: [
    { name: "All", value: 0, key: "ALL" },
    { name: "In", value: 1, key: "IN" },
    { name: "Out", value: 2, key: "OUT" },
    { name: "Reserved", value: 3, key: "Reserved" }
  ],
  branchRegions: [],
  conditions: []
};

const equipmentReducer = createReducer(
  {
    categoryList: [],
    subCategoryList: [],
    subCategoryLoader: false,
    category: "",
    equipmentList: [],
    equipmentTotal: "",
    equipmentDetail: {},
    equipmentLoader: true,
    equipmentFetchID: 0,
    user: {},
    employees: [],
    employeesLoader: false,
    branchList: [],
    branchListLoader: true,
    detailsFromTable: false,
    branchDetail: {},
    branchMaster: {},
    branchDetailLoader: false,
    contentLoader: false,
    wildcardFilter: [],
    ...initialState
  },
  {
    EQUIPMENT_START: (state, action) => {
      state.equipmentLoader = true;
      state.equipmentList = [];
    },
    EQUIPMENT_SUCCESS: (state, action) => {
      if (action.payload.newFetchID === state.equipmentFetchID) {
        state.equipmentLoader = false;
        state.equipmentList = action.payload.items;
        state.equipmentTotal = action.payload.totalCount;
        state.wildcardFilter = action.payload.extraData.wildcardFilter;
      }
    },
    EQUIPMENT_ERROR: (state, action) => {
      state.equipmentLoader = false;
      state.error = action.payload;
    },
    EQUIPMENTDETAILS_START: (state, action) => {
      state.equipmentDetail = {};
      state.employees = [];
      state.employeesLoader = true;
      state.branchDetailLoader = true;
      state.branchDetail = {};
    },
    EQUIPMENTDETAILS_SUCCESS: (state, action) => {
      state.branchDetailLoader = false;
      state.equipmentDetail = action.payload;
      state.detailsFromTable = false;
    },
    SETFETCHID: (state, action) => {
      state.equipmentFetchID = action.payload.fetchID;
    },
    SETDETAILS: (state, action) => {
      state.branchDetailLoader = false;
      state.equipmentDetail = action.payload;
      state.detailsFromTable = true;
    },
    EQUIPMENTDETAILS_ERROR: (state, action) => {
      state.branchDetailLoader = false;
      state.error = action.payload;
    },
    USER_START: (state, action) => {
      state.loading = true;
    },
    USER_SUCCESS: (state, action) => {
      state.loading = false;
      state.user = action.payload;
    },
    USER_ERROR: (state, action) => {
      state.user.validated = false;
    },
    BRANCH_START: (state, action) => {
      state.branchListLoader = true;
    },
    BRANCH_SUCCESS: (state, action) => {
      state.branchListLoader = false;
      state.branchList = action.payload;
    },
    BRANCH_ERROR: (state, action) => {
      state.branchListLoader = false;
      state.error = action.payload;
    },
    BRANCHDETAIL_START: (state, action) => {
      state.contentLoader = true;
      state.branchDetail = {};
      state.branchMaster = {};
    },
    BRANCHDETAIL_SUCCESS: (state, action) => {
      state.contentLoader = false;
      state.branchDetail = action.payload;
    },
    BRANCHDETAIL_ERROR: (state, action) => {
      state.contentLoader = false;
      state.error = action.payload;
    },
    BRANCHMASTER_SUCCESS: (state, action) => {
      state.branchMaster = action.payload;
    },
    BRANCHREGION: (state, action) => {
      state.branchRegions = action.payload;
    },
    CATEGORY_START: (state, action) => {},
    CATEGORY_SUCCESS: (state, action) => {
      state.categoryList = action.payload;
    },
    CATEGORY_ERROR: (state, action) => {
      state.error = action.payload;
    },
    SUBCATEGORY_START: (state, action) => {
      state.subCategoryLoader = true;
      state.subCategoryList = [];
    },
    SUBCATEGORY_SUCCESS: (state, action) => {
      state.subCategoryList = action.payload;
      state.subCategoryLoader = false;
    },
    EMPLOYEES_START: (state, action) => {
      state.employees = [];
      state.employeesLoader = true;
    },
    EMPLOYEES_SUCCESS: (state, action) => {
      state.employeesLoader = false;
      state.employees = action.payload;
    },
    EMPLOYEES_ERROR: (state, action) => {
      state.employeesLoader = false;
      state.error = action.payload;
    },
    CONDITIONS: (state, action) => {
      state.conditions = action.payload;
    }
  }
);

const rootReducer = combineReducers({
  equipmentReducer
});

export default rootReducer;
